import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';

export class TrimFormControl extends FormControl {
  private _value: string | null;
  public touchedChanges: Subject<boolean> = new Subject<boolean>();

  setValue(value: any) {
    if (value && value.trim() === '') {
      value = value ? value.trim() : value;
    }
    this._value = value;
    super.setValue(value);
  }

  getVAL(): string | null {
    return this._value;
  }

  markAsTouched({ onlySelf }: { onlySelf?: boolean } = {}): void {
    super.markAsTouched({ onlySelf });

    this.touchedChanges.next(true);
  }
}
